import { Card, Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { QuestionInputs } from "../../types";
import Criterion from "../Criterion";
import GenerationField from "../GenerationField";

interface ContentCriteriaProps {
  isEditing: boolean;
  skillId: string | undefined;
}

const ContentCriteria = ({ isEditing, skillId }: ContentCriteriaProps) => {
  const form = useFormContext<QuestionInputs>();
  const { control } = form;

  return (
    <Card>
      <Stack spacing={2}>
        <Criterion
          control={control}
          disabled={!isEditing}
        />
        <GenerationField
          name='criteriaComment'
          label='Комментарий к критериям'
          successText='Критерии сгенерированы'
          generationType='criteria'
          skillId={skillId}
          isEditing={isEditing}
        />
      </Stack>
    </Card>
  );
};

export default ContentCriteria;
